import {
  ApplicationConfig,
  importProvidersFrom,
  isDevMode,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { AbstractSecurityStorage, provideAuth } from 'angular-auth-oidc-client';
import { AuthService } from './core/auth/auth.service';
import { tokenInterceptor } from './core/auth/token.interceptor';
import { environment } from '../environments/environment';
import { errorInterceptor } from './core/error-handler/interceptor/error.interceptor';
import { courseDashboardReducer } from './dashboard/state/dashboard.reducer';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideEffects } from '@ngrx/effects';
import * as dashboardEffects from './dashboard/state/dashboard.effects';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideRouterStore } from '@ngrx/router-store';
import { CustomStorageService } from './core/auth/custom-storage.service';
export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(BrowserAnimationsModule),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([tokenInterceptor, errorInterceptor])), //-NOTE: Order of interceptors is important
    provideAuth({
      config: {
        authority: environment.settings.authAuthority,
        redirectUrl: window.location.origin,
        postLogoutRedirectUri: window.location.origin,
        clientId: environment.settings.clientId,
        scope: 'openid UnderstandingDyslexia IdentityServerApi offline_access',
        responseType: 'code',
        silentRenew: true,
        useRefreshToken: true,
        renewTimeBeforeTokenExpiresInSeconds: 30,
        maxIdTokenIatOffsetAllowedInSeconds: 600,
        // logLevel: LogLevel.Debug,
      },
    }),
    { provide: AbstractSecurityStorage, useClass: CustomStorageService },

    // { provide: AbstractLoggerService, useClass: ConsoleLogger },
    provideStore({ dashboard: courseDashboardReducer }),
    provideEffects(dashboardEffects.DashboardEffects),
    provideStoreDevtools({
      maxAge: 25,
      logOnly: !isDevMode(),
      features: {
        pause: true,
        lock: true,
        persist: true,
        export: true,
        import: 'custom',
      },
    }),
    AuthService,
    provideRouterStore(),
  ],
};
